import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MarcasService } from '../_services/marcas.service';
import { Marcas } from '../_model/marcas';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-relojoaria',
    templateUrl: './relojoaria.component.html',
    styleUrls: ['./relojoaria.component.less'],
    standalone: false
})
export class GestaoRelojoariaComponent implements OnInit {

  constructor(private marca: MarcasService, private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      if(params['marca']=='true') {
        this.links = [{link: 'admin', name: 'Administração'},{link: 'admin/marcas', name: 'Inserir Marcas'},{link: 'admin/gestaoMarcas', name: 'Gestão de Marcas'}]
      }
    });
  }
  links: any[] = [{link: 'admin', name: 'Administração'},{link: 'admin/gestaoMarcas', name: 'Gestão de Marcas'}];

  marcas: Marcas[] = [];

  ngOnInit() {
    this.marca.listPathOrder('relogio').subscribe((data: any[]) => {
      data.forEach((el: Marcas) => {
        this.marcas.push(new Marcas(el));
      })
    });
  }

  drop(event: CdkDragDrop<Marcas[]>) {
    moveItemInArray(this.marcas, event.previousIndex, event.currentIndex);
    this.marca.sendOrder('relogio',this.marcas).subscribe();
  }

}

